import { render, staticRenderFns } from "./AccommodationPage.vue?vue&type=template&id=54c55a16&scoped=true"
import script from "./AccommodationPage.vue?vue&type=script&lang=js"
export * from "./AccommodationPage.vue?vue&type=script&lang=js"
import style0 from "./AccommodationPage.vue?vue&type=style&index=0&id=54c55a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c55a16",
  null
  
)

export default component.exports